import { SecretManager } from '@api/secret-manager-handler';
import { SET_ACTIVE_SECRET_MANAGERS, SetActiveSecretManagers } from './types';

export const setActiveSecretManagers = (secretManagers: SecretManager[]): SetActiveSecretManagers => ({
    type: SET_ACTIVE_SECRET_MANAGERS,
    payload: secretManagers,
});
